module.exports = __webpack_public_path__ + "img/double-image-hero-honda.8ecd9ada.png";